import { createContext, useContext, useState } from 'react';
import api from '../utils/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });

  // Le token est un cookie httpOnly géré par le serveur — jamais accessible en JS.
  function login(userData) {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  }

  async function logout() {
    try { await api.post('/auth/logout'); } catch { /* best effort */ }
    localStorage.removeItem('user');
    localStorage.removeItem('lidwork_site');
    setUser(null);
    window.location.href = '/login';
  }

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
